// extracted by mini-css-extract-plugin
module.exports = {"item__link":"Item_item__link__2ro4o"};